import { createSolanaAddressId } from '@pkg/solana'
import type { SolanaConverterArgs } from '../type'

/**
 * トランザクションのfee payer（手数料支払者）が関連アドレスかどうかをチェック
 * Solanaでは、fee payerは常にトランザクションの最初のsigner（accountKeys[0]）
 *
 * @param args - ConvertToActionsの引数
 * @returns fee payerが関連アドレスの場合true
 */
export function isFeePayer(args: SolanaConverterArgs): boolean {
  const { transaction, relatedAddresses } = args

  // Fee payerは常に最初のaccount key
  if (!transaction.transaction.message.accountKeys?.[0]) {
    return false
  }

  // Fee payerはsignerでなければならない
  if (!transaction.transaction.message.accountKeys[0].signer) {
    return false
  }

  return relatedAddresses.has(
    createSolanaAddressId({
      address: transaction.transaction.message.accountKeys[0].pubkey,
    }),
  )
}
